export { FooterRender } from './FooterRender';
